import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

const ContentPage = ({ slug }) => {
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPage(null);
    setNotFound(false);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return <div className="py-24 text-center text-[#8A9A8D]">Page not found.</div>;
  if (!page) return <div className="py-24 text-center text-[#8A9A8D]">Loading...</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="font-serif font-bold text-3xl sm:text-4xl text-[#1C2B20]" data-testid="content-page-title">
        {page.title}
      </h1>
      <div className="mt-6 text-[#5A6B5D] leading-relaxed whitespace-pre-line" data-testid="content-page-body">
        {page.content}
      </div>
    </div>
  );
};

export default ContentPage;
